<template>
  <div class="bulk-update-queries-date-component">
    <header>
      <div>
        <h1>{{ $t('admin.bulk_update_queries_date.title') }}</h1>
      </div>
    </header>

    <div class="note">
      <div>
        <p>
          {{ $t('admin.bulk_update_queries_date.note', { total_folders: selectedFolders.length, total_queries: selectedQueries.length })}}
          <i class="fas fa-info-circle" v-tooltip="$t('admin.bulk_update_queries_date.bulk_update_date_tooltip')"></i>
        </p>
      </div>
    </div>

    <div class="form-wrapper">
      <div class="time-periods-wrapper">
        <div class="periods-row">
          <app-time-periods
            :queryPeriod="queryPeriod"
            :periods="periodsData"
            :period_types="period_types"
            :showPeriodType="false"
            :showPeriodTypeMessage="false"
            periodKey="range"
            @setQueryTimePeriod="onTimePeriodChange"
          />
        </div>
        
        <div class="action-wrapper">
          <button class="btn btn-default" @click="reset">
            <i class="fas fa-sync" /> {{ $t('admin.reset') }}
          </button>
          <button class="btn btn-carma" @click="save">
            <i class="fas fa-save" /> {{ $t('admin.save') }}
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TimePeriods from '@/components/coding-queries/time_periods.vue';
import dateHelper from "@/helpers/date";
import { QUERIES } from '@/config/const';

export default {
  name: "BulkUpdateQueriesDate",

  components: {
    'app-time-periods': TimePeriods
  },

  props: {
    selectedQueries: {
      type: Array,
      default: () => []
    },
    selectedFolders: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ...mapState({
      periods: state => state.queryBuilder?.periods?.periods || { data: null }
    }),

    projectId() {
      return this.$route.params.project_uid || this.$route.params.project_id;
    },

    periodsData() {
      return this.periods?.data?.periods || [];
    },

    period_types() {
      return this.periods?.data?.types || [];
    },

    queryPeriod() {
      return {
        type: this.formData.periodType || 'current',
        range: this.formData.dateRange || dateHelper.getQueryDefaultDateRange()
      };
    }
  },

  data() {
    return {
      formData: {
        periodType: QUERIES.TIME_PERIOD_TYPE.CURRENT,
        dateRange: dateHelper.getQueryDefaultDateRange(),
        includePeriod: false
      }
    }
  },

  methods: {
    
    onTimePeriodChange({ entity, value }) {
      if (entity === 'type') {
        this.formData.periodType = value;
      } else if (Array.isArray(entity) && entity[0] === 'range') {
        this.formData.dateRange = value;
      }
    },

    reset() {
      this.formData = {
        periodType: QUERIES.TIME_PERIOD_TYPE.CURRENT,
        dateRange: dateHelper.getQueryDefaultDateRange(),
        includePeriod: false
      };
    },

    save() {
      const data = {
        periodType: this.formData.periodType,
        dateRange: this.formData.dateRange,
        includePeriod: this.formData.includePeriod,
        queryIds: this.selectedQueries,
        folderIds: this.selectedFolders
      };

      this.$emit('onBulkUpdateQueriesDateSave', data);
    }
  }
}
</script>

<style lang="scss">
@import '../../../styles/base/variables.scss';

.bulk-update-queries-date-component {
  padding: 1rem;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;
    border-bottom: none;

    h1 {
      margin-right: 1.2rem;
      margin-bottom: 0;
    }
  }

  .note {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 2rem;
    color: $light-text;
    font-style: italic;
  }

  .form-wrapper {
    .time-periods-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 1rem;
      flex-wrap: wrap;

      .periods-row {
        display: flex;
        align-items: flex-start;
        gap: 1rem;
        position: relative;
        flex: 1;
        min-width: 0;
      }
    }
  }

  .action-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
    flex-shrink: 0;

    .btn {
      display: inline-flex;
      align-items: center;
      width: auto;
      font-size: 13px;
      padding: 10px 14px;
      line-height: 1.1;
      height: auto;
      margin-top: 0px !important;
    }
  }
}
</style>
